import { useEffect, useMemo, useState } from "react";
import { cmsAdminApi } from "../../api/cmsApi";

export default function AdminApplicationsPage() {
  const [apps, setApps] = useState([]);
  const [filter, setFilter] = useState("all");
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      setApps(await cmsAdminApi.listJobApplications());
      setError("");
    } catch (e) {
      setError(e.message || "Could not load applications");
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const filtered = filter === "all" ? apps : apps.filter((a) => a.status === filter);

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Job Applications</h1>
          <p>Applications submitted from the careers pages.</p>
        </div>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      <div className="admin-panel mb-3">
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <span className="text-muted small text-uppercase fw-bold me-1">Filter</span>
          {["all", "new", "reviewing", "shortlisted", "rejected"].map((f) => (
            <button
              key={f}
              type="button"
              className={`admin-btn admin-btn-sm${filter === f ? " admin-btn-primary" : " admin-btn-ghost"}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-panel">
        {filtered.length === 0 ? (
          <p className="admin-empty">No applications submitted yet.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Candidate</th>
                  <th>Role</th>
                  <th>Contact</th>
                  <th>Resume</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {filtered.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <strong>{a.name}</strong>
                      <div className="text-muted small">{new Date(a.createdAt).toLocaleString()}</div>
                    </td>
                    <td>{a.jobTitle}</td>
                    <td>
                      <div>{a.email}</div>
                      <div className="text-muted small">{a.phone || "—"}</div>
                    </td>
                    <td>
                      {a.hasResume ? (
                        <div className="d-flex flex-column gap-1">
                          <a
                            className="admin-link"
                            href={cmsAdminApi.jobApplicationResumeUrl(a.id, true)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Open {a.resumeName || "resume"}
                          </a>
                          <a
                            className="admin-link text-muted small"
                            href={cmsAdminApi.jobApplicationResumeUrl(a.id)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Download
                          </a>
                        </div>
                      ) : "—"}
                    </td>
                    <td>
                      <select
                        className="admin-select-sm"
                        value={a.status}
                        onChange={async (e) => {
                          await cmsAdminApi.updateJobApplicationStatus(a.id, e.target.value);
                          await refresh();
                        }}
                      >
                        <option value="new">new</option>
                        <option value="reviewing">reviewing</option>
                        <option value="shortlisted">shortlisted</option>
                        <option value="rejected">rejected</option>
                      </select>
                    </td>
                    <td className="admin-actions">
                      <button
                        type="button"
                        className="admin-btn admin-btn-sm admin-btn-danger"
                        onClick={async () => {
                          if (!window.confirm("Delete application?")) return;
                          await cmsAdminApi.deleteJobApplication(a.id);
                          await refresh();
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
